import { RecommendVoActionType } from '@/reducers/V2/V2Actions/RecommendVo/RecommendVoTypes';

const initialState: any = {
  recommendItems: [],
  selectedRecommendItems: [],
};

const UILogicReducer: (state: any, action: any) => any = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case RecommendVoActionType.SET_RECOMMEND_ITEMS:
      return {
        ...state,
        recommendItems: payload,
      };
    case RecommendVoActionType.SET_SELECTED_RECOMMEND_ITEMS:
      return {
        ...state,
        selectedRecommendItems: payload,
      };

    default:
      return state;
  }
};

export default UILogicReducer;
